// extracted by mini-css-extract-plugin
export default {"section":"Vx-z","sectionTitle":"Wx-z","fieldWrapper":"Xx-z","formField":"Yx-z","disabled":"Zx-z","formLabel":"_x-z"};